import { AzureADAppPermissionGrantModel } from '../../../microsoft/azuread/profile/azure-adapp-permission-grant-model';
import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';

export class AzureADReportProfileAlertGrantsModel extends ReportProfileAlertResourceBaseModel {
  grants: AzureADAppPermissionGrantModel;
}
